// Filter for illegal characters
export const hasIllegalCharacters = (inputText, isUriValidation = false) => {
  // Convert to string if it's a number or other type
  const textToValidate = String(inputText);

  // Illegal characters in standard user input fields (name, email, etc.)
  const illegalFieldInputCharacters = ['%', '<', '>', '[', ']', '{', '}'];

  if (isUriValidation) {
    illegalFieldInputCharacters.push("*"); // disallow '*' for URI values, allow '&'.
  } else {
    illegalFieldInputCharacters.push("&"); // disallow '&' for non-URI values, allow '*'
  }

  return illegalFieldInputCharacters.some((char) => textToValidate.indexOf(char) > -1);
};

export const isValidEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

// URI validation
export const isValidURI = require('validate.io-uri');


